import {Component} from '@angular/core';
import {RoutingService} from 'src/app/infrastructure/routing/routing.service';

@Component({
  selector: 'app-animal-ping-schedule-button',
  templateUrl: './animal-ping-schedule-button.component.html',
  styleUrl: './animal-ping-schedule-button.component.css'
})
export class AnimalPingScheduleButtonComponent {

  constructor(
    protected routingService: RoutingService
  ) {}
}
